package kz.dentalcrm.app.di

import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.URLBuilder
import io.ktor.http.takeFrom
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.qualifier.named
import org.koin.dsl.module

const val PROD_URL = "https://prod-app.dentra.me"
const val DEV_URL = "https://dev-app.dentra.me"

const val BASE_URL = PROD_URL
const val NETWORK = "Network"

fun networkModule() = module {
    single<Json>(named("contentSerializer")) {
        Json {
            ignoreUnknownKeys = true
            prettyPrint = true
            coerceInputValues = true
            encodeDefaults = true
            isLenient = true
        }
    }
    single<HttpClient> {
        HttpClient {
            defaultRequest {
                url.takeFrom(URLBuilder().takeFrom(BASE_URL))
            }
            install(HttpTimeout) {
                @Suppress("MagicNumber")
                requestTimeoutMillis = 60_000
            }
            install(ContentNegotiation) {
                json(get(named("contentSerializer")))
            }
            if (BASE_URL == DEV_URL) {
                install(Logging) {
                    level = LogLevel.ALL
                    logger = object : Logger {
                        override fun log(message: String) {
                            co.touchlab.kermit.Logger.i("Network:") {
                                message
                            }
                            //NETWORK.showILog(message)
                        }
                    }
                }
            }

            // TODO Ask Asylkhan about error body)
//            HttpResponseValidator {
//
//                handleResponseExceptionWithRequest { cause, _ ->
//                    val clientException = cause as? ClientRequestException ?: return@handleResponseExceptionWithRequest
//                    val exceptionResponse = clientException.response
//                    val error = Json.decodeFromString<ErrorData>(exceptionResponse.bodyAsText())
//                    throw CustomizedException(
//                        code = cause.response.status.value,
//                        message = error.message
//                    )
//                }
//            }
        }
    }
}